module.exports = __webpack_public_path__ + "static/media/eth.svg.0da9a224.png";